<template>
  <div id="loader-state" class="loader-state">
    <clip-loader color="#047be3" size="30px"></clip-loader>
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
export default {
  name: 'Loader',
  components: {
    ClipLoader
  }
}
</script>

<style>
.loader-state {
  position: fixed;
  left: 45%;
  top: 50%;
}
</style>
